import PropTypes from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'
import FunnelGraph from 'funnel-graph-js'
import Heading from '@react/react-spectrum/Heading'
import Well from '@react/react-spectrum/Well'
import _ from 'lodash'

import { ProfileContext } from '../../../root/ProfileContext'
import { RootContext } from '../../../root/RootContext'
import { EE, CHANNELS, CHANNEL } from '../../../config/constants'

import './ConversionFunnel.scss'

export default function ConversionFunnel({ meta, content }) {
  const rootContext = useContext(RootContext)
  const profileContext = useContext(ProfileContext)
  const currentProfile = profileContext.state.currentProfile
  const [data, setData] = useState()
  const tenantId = '_' + rootContext?.project?.integrations?.aep?.imsOrg?.tenantID
  const channel = CHANNEL.replace('$tenantId', tenantId)

  //Web data
  const webProductViews = currentProfile?.experienceEvents?.filter(
    (event) => event.entity.eventType === EE.PRODUCT_VIEW && _.get(event, `entity.${channel}`) === CHANNELS.WEB
  )
  const webProductAddedToCart = currentProfile?.experienceEvents?.filter(
    (event) => event.entity.eventType === EE.ADD_TO_CART && _.get(event, `entity.${channel}`) === CHANNELS.WEB
  )
  const webPurchases = currentProfile?.experienceEvents?.filter(
    (event) => event.entity.eventType === EE.CHECKOUT && _.get(event, `entity.${channel}`) === CHANNELS.WEB
  )

  //Mobile data
  const mobileProductViews = currentProfile?.experienceEvents?.filter(
    (event) => event.entity.eventType === EE.PRODUCT_VIEW && _.get(event, `entity.${channel}`) === CHANNELS.MOBILE
  )
  const mobileProductAddedToCart = currentProfile?.experienceEvents?.filter(
    (event) => event.entity.eventType === EE.ADD_TO_CART && _.get(event, `entity.${channel}`) === CHANNELS.MOBILE
  )
  const mobilePurchases = currentProfile?.experienceEvents?.filter(
    (event) => event.entity.eventType === EE.CHECKOUT && _.get(event, `entity.${channel}`) === CHANNELS.MOBILE
  )

  useEffect(() => {
    if (Array.isArray(currentProfile?.experienceEvents)) {
      const kpiData = {
        labels: ['VIEWS', 'ADD TO CART', 'PURCHASED'],
        subLabels: ['ONLINE', 'MOBILE APP'],
        colors: [
          ['rgb(0, 58, 190,0.3)', 'rgb(0, 58, 190,0.7)', 'rgb(0, 58, 190)'],
          ['rgb(191, 136, 255,0.3)', 'rgb(191, 136, 255,0.7)', 'rgb(191, 136, 255)'],
        ],
        values: [
          [webProductViews.length, mobileProductViews.length],
          [webProductAddedToCart.length, mobileProductAddedToCart.length],
          [webPurchases.length, mobilePurchases.length],
        ],
      }
      setData(kpiData)
    }
    return function cleanup() {
      if (document.getElementById('funnel') != null) {
        document.getElementById('funnel').innerHTML = ''
      }
    }
  }, [currentProfile])

  return (
    <div className='profile-module conversion-funnel'>
      <div className='funnel-container'>
        {currentProfile && currentProfile.experienceEvents && (
          <>
            {content.description && <Well>{content.description}</Well>}
            <div id='funnel' className='funnel'></div>
            {data && <FunnelGraphWrapper container='.funnel' data={data} />}
          </>
        )}
      </div>
    </div>
  )
}

function FunnelGraphWrapper({ container, data }) {
  //@todo use appendChild to create the component dynamically
  if (data != undefined) {
    const graph = new FunnelGraph({
      container: container,
      width: 800,
      height: 350,
      gradientDirection: 'horizontal',
      data: data,
      displayPercent: true,
      direction: 'horizontal',
    })
    graph.draw()
  }

  return <></>
}

ConversionFunnel.requiresLaunch = true
